<tilby-dialog-toolbar title="SETTINGS.SETTINGS.DIGITAL_HUB_OWNED.TITLE" [disabled]="digitalHubCredentials.invalid || isWorking" (confirm)="confirm()"/>
@if(isWorking) {
    <tilby-dialog-progress-bar/>
}
<tilby-dialog-content>
    <div class="tw-flex tw-flex-col">
        <form [formGroup]="digitalHubCredentials" class="tw-flex-col">
            <div class="tw-flex">
                <img style="margin: auto;" src="assets/images/history/digital_hub.png" />
            </div>
            <div class="tw-flex tw-flex-col">
                <mat-form-field>
                    <mat-label>{{'SETTINGS.SETTINGS.DIGITAL_HUB_OWNED.USERNAME' | translate}}</mat-label>
                    <input matInput type="text" formControlName="userName"/>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>{{'SETTINGS.SETTINGS.DIGITAL_HUB_OWNED.PASSWORD' | translate}}</mat-label>
                    <input matInput type="password" formControlName="password"/>
                </mat-form-field>
            </div>
        </form>
    </div>
</tilby-dialog-content>

